// @flow
import 'vizor-react-vr/src/renderer/MediaScreen/DOMMediaScreen/DOMMediaScreen.css'  // NB: PostCSS loader
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import trackEvent from './trackEvent'

// /:owner/:name
// /embed/:owner/:name
const pathSplit = window.location.pathname.split('/')
const isEmbed = pathSplit[1] === 'embed'
const [owner, name] = pathSplit.slice(-2)

trackEvent({
  event: isEmbed ? 'embeddedPlayerOpened' : 'playerOpened',
  path: window.location.pathname,
})

trackEvent({
  event: isEmbed ? 'embeddedPlayerPlaying' : 'playerPlaying',
  path: window.location.pathname,
})

fetch(`./file.json`)
.then(response => response.json())
.then((file) => {
  ReactDOM.render(<App file={file} />,
    document.getElementById('root'))
})



// WEBPACK FOOTER //
// ./src/index.js